import { useEffect, useRef } from "react";
import { breathState } from "../../lib/breath";

export function BreathDebug({ mic }) {
  const ref = useRef(null);
  useEffect(() => {
    const id = setInterval(() => {
      const s = breathState;
      if (!ref.current) return;
      const f = (v) => (v === null || v === undefined ? "–" : v);
      ref.current.textContent = [
        `mic ${mic} · phase ${s.phase} · ctx ${s.ctx} @ ${s.rate || "–"}Hz`,
        `low ${f(s.low)} dB · floor ${f(s.floor?.toFixed?.(1))} · thr ${f(s.thr)}`,
        `hiss ${f(s.hiss)} / ${f(s.hissFloor?.toFixed?.(1))} · flat ${f(s.flat)}`,
        `pre ${s.pre} · level ${s.level} · active ${s.active} · gusts ${s.gusts}`,
        `ec ${f(s.settings?.ec)} ns ${f(s.settings?.ns)} agc ${f(s.settings?.agc)}${s.silent ? " · SILENT INPUT" : ""}`,
        `live ${"█".repeat(Math.round(Math.max(0, Math.min(24, ((s.low ?? -140) - (s.floor ?? -100)) / 1.5))))}`,
      ].join("\n");
    }, 100);
    return () => clearInterval(id);
  }, [mic]);
  return <pre ref={ref} data-testid="breath-debug" className="pointer-events-none absolute right-3 top-20 z-40 whitespace-pre rounded-lg bg-black/65 p-3 font-mono text-[11px] leading-snug text-white" />;
}
